import type {ReactElement} from 'react';
import type {ProgressiveBlurOverlayProps} from './progressive-blur-overlay.types';
import styles from './progressive-blur-overlay.module.scss';

const BLUR_LAYER_COUNT = 7;

export function ProgressiveBlurOverlay({className = '', horizontalFade = false}: ProgressiveBlurOverlayProps): ReactElement {
  return (
    <div className={`${styles.overlay} ${horizontalFade ? styles.horizontalFade : ''} ${className}`} aria-hidden="true">
      {Array.from({length: BLUR_LAYER_COUNT}, (_, index) => (
        <div key={index} className={styles.blurFilter} />
      ))}
    </div>
  );
}
